import { Plus, Trash2 } from "lucide-react";
import {
  FK, Field, Row, TextInput, SuffixInput, Checkbox, Pill, FkPrimary, FkGhost, FkOutline,
} from "../product_config/formkit";

export default function DescuentosBaseTab({
  descuentosBase,
  setDescuentosBase,
  newDescuento,
  setNewDescuento,
  showDescuentosForm,
  setShowDescuentosForm,
  handleAddDescuento,
  handleRemoveDescuento,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <FkOutline onClick={() => setShowDescuentosForm(!showDescuentosForm)}>
          <Plus size={16} /> Agregar descuento
        </FkOutline>
      </div>

      {showDescuentosForm && (
        <div style={{ border: "1px solid " + FK.border, borderRadius: 12, background: FK.field, padding: 18 }}>
          <Row>
            <Field label="Cargas mínimas" required htmlFor="d-cmin">
              <TextInput id="d-cmin" type="number" value={newDescuento.cargas_min} onChange={(e) => setNewDescuento({ ...newDescuento, cargas_min: e.target.value })} placeholder="1" />
            </Field>
            <Field label="Cargas máximas" htmlFor="d-cmax">
              <TextInput id="d-cmax" type="number" value={newDescuento.cargas_max} onChange={(e) => setNewDescuento({ ...newDescuento, cargas_max: e.target.value })} placeholder="5" />
            </Field>
          </Row>
          <div style={{ height: 18 }} />
          <Row>
            <Field label="Porcentaje" required htmlFor="d-pct">
              <SuffixInput id="d-pct" type="number" value={newDescuento.porcentaje} onChange={(e) => setNewDescuento({ ...newDescuento, porcentaje: e.target.value })} placeholder="10,00" suffix="%" />
            </Field>
            <Field label="Tipo de carga" htmlFor="d-tipo">
              <TextInput id="d-tipo" value={newDescuento.tipo_carga} onChange={(e) => setNewDescuento({ ...newDescuento, tipo_carga: e.target.value })} placeholder="familiar, individual, etc." />
            </Field>
          </Row>
          <div style={{ marginTop: 14 }}>
            <Checkbox id="d-acum" checked={newDescuento.acumulable} onChange={(v) => setNewDescuento({ ...newDescuento, acumulable: v })} label="Acumulable con otros descuentos" />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
            <FkGhost onClick={() => setShowDescuentosForm(false)}>Cancelar</FkGhost>
            <FkPrimary onClick={handleAddDescuento}>Agregar</FkPrimary>
          </div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {descuentosBase.length === 0 && (
          <div style={{ textAlign: "center", padding: "28px 0", fontSize: 13, color: FK.muted }}>Sin descuentos configurados.</div>
        )}
        {descuentosBase.map((descuento, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "12px 14px", border: "1px solid " + FK.border, borderRadius: 12, background: FK.surface }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <Pill tone="muted">{descuento.cargas_min} - {descuento.cargas_max || "∞"} cargas</Pill>
              <span style={{ fontSize: 14, fontWeight: 600, color: FK.text }}>{descuento.porcentaje}% descuento</span>
              {descuento.tipo_carga && <Pill tone="muted">{descuento.tipo_carga}</Pill>}
              {descuento.acumulable && <Pill tone="ok">Acumulable</Pill>}
            </div>
            <button type="button" onClick={() => handleRemoveDescuento(index)} title="Quitar"
              style={{ appearance: "none", border: "none", background: "transparent", cursor: "pointer", color: FK.muted, padding: 6, borderRadius: 8, display: "grid", placeItems: "center" }}>
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
